interface SettingsIconProps {
  className?: string;
  size?: number;
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function SettingsIcon({ className = '', size = 24, color = 'white' }: SettingsIconProps) {
  return (
    <svg
      width={size}
      // The artwork is 24x22 — a square `size` would squash it.
      height={(size * 22) / 24}
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.5088 0.875C16.9777 0.875 18.3356 1.65615 19.0742 2.92578L22.5649 8.92578C23.3107 10.2079 23.3107 11.7921 22.5649 13.0742L19.0742 19.0742C18.3356 20.3438 16.9777 21.125 15.5088 21.125H8.49072C7.02176 21.125 5.66242 20.344 4.92383 19.0742L1.43457 13.0742C0.6888 11.7921 0.688799 10.2079 1.43457 8.92578L4.92383 2.92578C5.66241 1.65601 7.02176 0.875 8.49072 0.875H15.5088ZM8.49072 3.125C7.82318 3.125 7.20492 3.47972 6.86914 4.05664L3.37988 10.0566C3.0409 10.6394 3.0409 11.3606 3.37988 11.9434L6.86914 17.9434C7.20492 18.5203 7.82318 18.875 8.49072 18.875H15.5088C16.1762 18.875 16.7931 18.5201 17.1289 17.9434L20.6196 11.9434C20.9586 11.3606 20.9586 10.6394 20.6196 10.0566L17.1289 4.05664C16.7931 3.47991 16.1762 3.125 15.5088 3.125H8.49072Z"
        fill={color}
      />
      <path
        d="M13.875 11C13.875 9.96447 13.0355 9.125 12 9.125C10.9645 9.125 10.125 9.96447 10.125 11C10.125 12.0355 10.9645 12.875 12 12.875C13.0355 12.875 13.875 12.0355 13.875 11ZM16.125 11C16.125 13.2782 14.2782 15.125 12 15.125C9.72183 15.125 7.875 13.2782 7.875 11C7.875 8.72183 9.72183 6.875 12 6.875C14.2782 6.875 16.125 8.72183 16.125 11Z"
        fill={color}
      />
    </svg>
  );
}
